import React from 'react'

import { Button, Checkbox, Form, message, Select } from 'antd'

import { observer } from 'mobx-react-lite'

import { Page } from 'common/components/Page'
import { NotificationFrequency } from 'common/server/server_types'

import { useVendorStores } from 'vendor/hooks/use-stores'

interface VendorUserNotifications {
  notification_frequency: NotificationFrequency
  daily_reminder_email: boolean
}

export const Notifications = observer(() => {
  const { userStore } = useVendorStores()

  const [form] = Form.useForm()

  React.useEffect(() => {
    form.setFieldsValue(userStore.currentUser)
  }, [userStore.currentUser])

  const onSubmit = async (values: VendorUserNotifications): Promise<void> => {
    try {
      await userStore.updateNotificationsSetting(values)
      message.success('Notification setting updated successfully')
    } catch (err) {
      console.error('Unable to update', err)
      message.error('Unable to update your notification setting')
    }
  }

  return (
    <>
      <Page.Header p={8} />

      <Page.Content>
        <Form layout="vertical" form={form} name="edit-user-notification-setting" onFinish={onSubmit}>
          <Form.Item name="notification_frequency" label="Frequency you will receive notification emails">
            <Select style={{ width: '300px', marginRight: '20px' }}>
              {Object.keys(NotificationFrequency).map((role) => (
                <Select.Option key={role} value={role}>
                  {NotificationFrequency[role]}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item valuePropName="checked" name="daily_reminder_email">
            <Checkbox>Daily reminder email </Checkbox>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </Page.Content>
    </>
  )
})
